import {
  Component,
  EventEmitter,
  Input,
  NgModule,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { DxFormComponent, DxFormModule } from "devextreme-angular";
import { MatrixColumnFormData } from "../../../../../model/calculation/optionPriceInformation";
import { formatMessage } from "devextreme/localization";
import {
  DxiItemModule,
  DxiValidationRuleModule,
} from "devextreme-angular/ui/nested";
import { OptionFormData } from "../../../../../model/calculation/optionFormData";
import { ValidationPattern } from "../../../../../utils/patternUtils";

@Component({
  selector: "app-matrix-column-form",
  templateUrl: "./matrix-column-form.component.html",
  styleUrls: ["./matrix-column-form.component.scss"],
})
export class MatrixColumnFormComponent implements OnInit {
  @ViewChild(DxFormComponent) form: DxFormComponent;

  formatMessage = formatMessage;

  @Input() columnFormData: MatrixColumnFormData;
  @Input() optionData: OptionFormData;
  @Output() columnFormDataChange = new EventEmitter<MatrixColumnFormData>();

  numberPattern = ValidationPattern.ONLY_NUMERIC;
  constructor() {
    this.checkFormValueUnique = this.checkFormValueUnique.bind(this);
  }

  ngOnInit(): void {}

  resetValues(): void {
    this.form.instance.resetValues();
  }

  isValid(): boolean | undefined {
    return this.form.instance.validate().isValid;
  }

  checkFormValueUnique(data: any): boolean {
    const { valueTo } = data;
    const { columns } = this.optionData;
    const { index } = this.columnFormData;
    const foundIndex = columns.findIndex((column) => column.valueTo == valueTo);

    return !(foundIndex > -1 && index != foundIndex);
  }
}

@NgModule({
  imports: [DxFormModule, DxiItemModule, DxiValidationRuleModule],
  declarations: [MatrixColumnFormComponent],
  exports: [MatrixColumnFormComponent],
})
export class MatrixColumnFormModule {}
